import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Marquee from "../../components/Marquee/Marquee";
import TrendingStocks from "../../components/TrendingStocks/Trendindstock";
import Watchlist from "../../components/Watchlist/Watchlist";
import { WatchModel } from "../../components/Watchlist/WatchlistModel";
import { HomeModel } from "./Homemodel";

const Home: React.FC = () => {

  const homeModel = HomeModel();
  const watchModel = WatchModel();
  return (<>
    <Header></Header>
    <main className="main">
      <div className="container">
        <div className="pagetitle">

          <nav className="py-2">

            <Marquee></Marquee>
          </nav>
        </div>


        <div className="calender">

          <nav className="py-2">

            <ul className="d-flex align-items-center text-white">

              {homeModel.dates && homeModel.dates.map((d: any, index: number) => (

                <li className="nav-item d-block calender-border me-3" key={index} onClick={(e) => homeModel.getDataBydate(d)}>
                  <a className="nav-link nav-icon search-bar-toggle fs-12 fw-600 text-center mt-1" href="#">
                    {d.date}
                  </a>
                  <p className="text-center mb-0 fs-13 fw-600 text-warning">{d.COUNT}</p>
                </li>
              ))}



            </ul>
          </nav>
        </div>

        <section className="section dashboard">
          <div className="row">

            <div className="col-lg-3">


              <TrendingStocks />


            </div>


            <div className="col-lg-6">
              <div className="row">





                <div className="col-12">
                  <div className="card-head mb-2 card-bg">
                    <ul className="nav nav-tabs d-flex border-0" id="myTabjustified" role="tablist">
                      <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 rounded active border-0 fs-14 fw-600 btn-text" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-justified" type="button" role="tab" aria-controls="home" aria-selected="false" tabIndex={-1}> Catalyst</button>
                      </li>

                      <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 rounded border-0 fs-14 fw-600 btn-text" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-justified" type="button" role="tab" aria-controls="contact" aria-selected="true">Most Active</button>
                      </li>
                    </ul>
                  </div>

                  <div className="tab-content pt-2" id="myTabjustifiedContent">
                    <div className="tab-pane fade active show" id="home-justified" role="tabpanel" aria-labelledby="home-tab">
                      <div className="row border-bottom_card">
                        <div className="col-8">
                          <div className="d-flex align-items-center mb-2">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <img src="/assets/img/profile-img.jpg" alt="Profile" className="rounded-circle w-100" />
                            </div>
                            <div className="ps-3">
                              <h6 className="fw-600 mb-0 fs-17 pe-1 title-color d-flex">Suri  <span className="verified-tick d-flex justify-content-center ms-1"><i className="bi bi-check-lg fs-12"></i></span>  </h6>
                              <p className="date-time fs-12">19-10-2023 09:25</p>
                            </div>

                          </div>

                        </div>
                        <div className="col-4">
                          <p className="float-end rounded-circle bg-color_ct padding-cus mt-2"><span className="fs-13 fw-600">CT</span></p>
                        </div>

                      </div>
                      <div className="row">
                        <div className="col-8">
                          <div className="d-flex align-items-center mb-2">

                            <div className="ps-3 mt-2">
                              <h6 className="mb-0 fs-13 pe-1 title-color d-flex mb-1">BAOS</h6>
                              <p className="date-time fs-13">Higher Stock</p>
                            </div>

                          </div>

                        </div>
                        <div className="col-4">
                          <p className="float-end fs-13 date mt-2 fw-600">19-10-2023</p>
                        </div>
                        <div className="col-12 text-center">
                          <img src="https://kuvera.in/blog/wp-content/uploads/2022/05/Line-Chart.png" alt="" />
                        </div>
                        <div className="col-12 mt-2">

                          <button type="button" className="btn btn-reward w-100 fs-15 fw-600" data-bs-toggle="modal" data-bs-target="#rewardPopup">
                            Reward
                          </button>



                        </div>
                      </div>

                    </div>


                    <div className="tab-pane fade " id="contact-justified" role="tabpanel" aria-labelledby="contact-tab">

                      {
                        homeModel.lstMostActive && homeModel.lstMostActive.map((d: any, index: number) => (
                          <div key={index}>
                            <div className="card">
                              <div className="card-body p-13">
                                <div className="row border-bottom_card">
                                  <div className="col-8">
                                    <div className="d-flex align-items-center mb-2">
                                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                        <img src={homeModel.imagePath + d.UserImage} alt="Profile" className="rounded-circle rounded-circle-image w-100" />
                                      </div>
                                      <div className="ps-3 my-auto">
                                        <h6 className="fw-600 mb-0 fs-17 pe-1 title-color d-flex">{d.UserName}
                                          <span className="verified-tick d-flex justify-content-center ms-1"><i className="bi bi-check-lg fs-12"></i></span>
                                        </h6>
                                        <p className="date-time fs-12  m-0">{d.CreatedDate}</p>
                                      </div>

                                    </div>

                                  </div>
                                  <div className="col-4 my-auto">
                                    {d.Type == 'Chart' ? <p className="float-end rounded-circle bg-color_ct padding-cus1"><span className="fs-13 fw-600 d-flex">C</span></p> : ''}
                                    {d.Type == 'Catalyst' ? <p className="float-end rounded-circle bg-color_ct padding-cus1"><span className="fs-13 fw-600 d-flex">CT</span></p> : ''}
                                    {d.Type == 'Twit' ? <p className="float-end rounded-circle bg-color_ct padding-cus1"><span className="fs-13 fw-600 d-flex">T</span></p> : ''}
                                  </div>

                                </div>
                                <div className="row">
                                  <div className="col-8">
                                    <div className="d-flex align-items-center mb-2">

                                      <div className="ps-1 mt-2">
                                        <h6 className="mb-0 fs-13 pe-1 title-color d-flex mb-1">{d.Ticker}</h6>
                                        <p className="date-time fs-13">{d.Message}</p>
                                      </div>

                                    </div>

                                  </div>
                                  <div className="col-4">
                                    <p className="float-end fs-13 date mt-2">Target days ({d.Period})</p>
                                  </div>

                                  <div className="col-3 col-md-3 p-0">
                                    <p className="date-time fs-13 mb-0">Stop Loss</p>
                                    <p className="date fs-13 mb-0">{d.Exit}</p>
                                  </div>
                                  <div className="col-3 col-md-3 p-0">
                                    <p className="date-time fs-13 mb-0">Entry Price</p>
                                    <p className="date fs-13 mb-0">{d.Entry}</p>
                                  </div>
                                  <div className="col-3 col-md-3 p-0">
                                    <p className="date-time fs-13 mb-0">Target Price</p>
                                    <p className="date fs-13 mb-0">{d.Target}</p>
                                  </div>
                                  <div className="col-3 col-md-3 p-0">
                                    <p className="date fs-13 mb-0">{watchModel.getLastPriceByTicker(d.Ticker, 'lastSale')}</p>

                                    {watchModel.getLastPriceByTicker(d.Ticker, 'netChange') < 0 ?
                                      <p className="date-time fs-13 mb-3 color_percent" >
                                        {watchModel.getLastPriceByTicker(d.Ticker, 'netChange')}
                                        ({watchModel.getLastPriceByTicker(d.Ticker, 'pctChange')})
                                      </p>
                                      :

                                      <p className="date-time fs-13 mb-3 text-color " >
                                        {watchModel.getLastPriceByTicker(d.Ticker, 'netChange')}
                                        ({watchModel.getLastPriceByTicker(d.Ticker, 'pctChange')})
                                      </p>

                                    }



                                  </div>

                                  <div className="col-12 text-center p-0">
                                    <img src={homeModel.imagePath + d.ImageName} alt="charts twits" />
                                  </div>
                                  <div className="col-md-12">
                                    <div className="row">
                                      <div className="col-4 pt-2 text-start">
                                        {
                                          d.Liked == 1 ?
                                            <a onClick={(e) => homeModel.reactionClick(d, 'like')} className="px-2 date-time fs-18 text-danger"><i className="bi bi-heart-fill"></i></a>
                                            :
                                            <a onClick={(e) => homeModel.reactionClick(d, 'like')} className="px-2 date-time fs-18"><i className="bi bi-heart"></i></a>
                                        }


                                        <a href="" className="date-time fs-18 px-3"><i className="bi bi-share"></i></a>

                                      </div>

                                      <div className="col-8 text-end pt-2">
                                        <p className="date-time fs-13" data-bs-toggle="modal" data-bs-target="#commentPopup" onClick={(e)=>homeModel.addComment(d)}>Add / View comment <span><i className="bi bi-plus-circle"></i></span></p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12 mt-2">

                                    <button type="button" onClick={(e) => homeModel.rewardUser(d)} className="btn btn-reward w-100 fs-15 fw-600" data-bs-toggle="modal" data-bs-target="#rewardPopup">
                                      Reward
                                    </button>



                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      }




                    </div>
                  </div>
                </div>






              </div>
            </div>



            <div className="col-lg-3">

              <Watchlist />


            </div>

          </div>




          <div className="floatingButtonWrap">
            <div className="floatingButtonInner">
              <a href="#" className="floatingButton">
                <i className="fa fa-plus icon-default"></i>
              </a>
              <ul className="floatingMenu">
                <li className="d-flex justify-content-end mb-3">
                  <a href="#">Group</a>
                  <span className="rounded-circle b-shadow" ><i className="bi bi-people-fill"></i></span>
                </li>
                <li className="d-flex justify-content-end mb-3">
                  <a href="#">Catalyst</a>
                  <span className="rounded-circle b-shadow" ><i className="fa-solid fa-file-lines"></i></span>
                </li>
                <li className="d-flex justify-content-end mb-3">
                  <a href="#">Post</a>
                  <span className="rounded-circle b-shadow" ><i className="fa-solid fa-rocket"></i></span>
                </li>
              </ul>
            </div>
          </div>


          <div className="floatingButtonWrap1">
            <div className="floatingButtonInner1">
              <a href="#" className="floatingButton1">
                <i className="fa-solid fa-rotate-right"></i>
              </a>
            </div>
          </div>
        </section>



      </div>




      <div className="modal fade" id="rewardPopup" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="rewardPopupLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="rewardPopupLabel">Points</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-1 col-1"></div>
                <div className="col-md-2 col-2" onClick={(e) => homeModel.reward(10)}>
                  <img src="assets/img/points/1.png" alt="" className="w-100 brd-50" />
                  {homeModel.rewardpoint == 10 ? <i className="bi bi-check f-30" ></i> : ''}
                </div>
                <div className="col-md-2 col-2" onClick={(e) => homeModel.reward(20)}>
                  <img src="assets/img/points/2.png" alt="" className="w-100 brd-50" />
                  {homeModel.rewardpoint == 20 ? <i className="bi bi-check f-30" ></i> : ''}
                </div>
                <div className="col-md-2 col-2" onClick={(e) => homeModel.reward(30)}>
                  <img src="assets/img/points/3.png" alt="" className="w-100 brd-50" />
                  {homeModel.rewardpoint == 30 ? <i className="bi bi-check f-30" ></i> : ''}
                </div>
                <div className="col-md-2 col-2" onClick={(e) => homeModel.reward(40)}>
                  <img src="assets/img/points/4.png" alt="" className="w-100 brd-50" />
                  {homeModel.rewardpoint == 40 ? <i className="bi bi-check f-30" ></i> : ''}
                </div>
                <div className="col-md-2 col-2" onClick={(e) => homeModel.reward(50)}>
                  <img src="assets/img/points/5.png" alt="" className="w-100 brd-50" />
                  {homeModel.rewardpoint == 50 ? <i className="bi bi-check f-30" ></i> : ''}
                </div>
                <div className="col-md-1 col-1"></div>
              </div>
            </div>
            <div className="modal-footer">
              {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
              <button type="button" className="btn btn-reward w-100 fs-15 fw-600" onClick={homeModel.saveReward}>Award</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="commentPopup" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="commentPopupLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={homeModel.postComment}>
            <div className="modal-header">
              <h5 className="modal-title" id="commentPopupLabel">Comment</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <textarea name="ChartComment" id="" cols={30} rows={5} className="form-control" placeholder="Add Comment..." 
                  onChange={homeModel.handleChange}></textarea>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
              <button type="submit" className="btn btn-reward w-100 fs-15 fw-600" >Post</button>
            </div>
            </form>
          </div>
        </div>
      </div>


      <div className="modal fade" id="alerts" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="alertsPopupLabel" aria-hidden="true">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="alertsPopupLabel">Action</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="row">
                  <div className="col-md-12">
                    
                      <h5>{homeModel.rewardStatus}</h5>

                    <button className="btn btn-light" data-bs-dismiss="modal" aria-label="Close">Ok</button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button type="button" className="btn btn-reward w-100 fs-15 fw-600" id="alertAction" style={{'visibility':'hidden'}} data-bs-toggle="modal" data-bs-target="#alerts">Reward</button>
                                    
    </main>
    <Footer></Footer>
  </>)
}
export default Home;